<section class='applied-filters'>
  <ng-container *ngIf='isMobile || appliedFilters?.length'>
    <div class='applied-filters__header'>
      <span class='applied-filters__title' i18n='@@filters__title'>Filtros</span>
      <span class='applied-filters__remove' *ngIf='appliedFilters?.length' (click)='allFiltersRemoved.emit()'>
        <mb-icon icon='trash'></mb-icon>
        <span i18n='@@applied-filters__remove'>Borrar todos</span>
      </span>
    </div>
  </ng-container>
  <div class='applied-filters__list'>
    <mb-chips>
      <ng-container *ngFor='let filter of appliedFilters'>
        <ng-container *ngIf='!filter?.values; else iterateFilters'>
          <mb-chip (dismiss)='changeFilter(filter.type, filter)'>
            {{ filter?.description }}
          </mb-chip>
        </ng-container>
        <ng-template #iterateFilters>
          <mb-chip *ngFor='let item of filter?.values' (dismiss)='changeFilter(filter.type, item)'>
            <ng-container *ngIf="filter.type === 'PRICE_RANGE'; else defaultChip">
              {{ (item?.from || item?.min) | currency:  '$' :'code' }}
              - {{ (item?.to || item?.max) | currency: '$' :'code'  }}
            </ng-container>
            <ng-template #defaultChip>
              {{ item?.description }}
            </ng-template>
          </mb-chip>
        </ng-template>
      </ng-container>
    </mb-chips>
  </div>
</section>
